import styled from 'styled-components';
import { Link } from '@ts/components/PrefetchRoute';

export const BackgroundLock = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100000;
    background: rgba(0, 0, 0, 0.5);
    display: ${(props) => (props.navigationIsOpen ? 'block' : 'none')};
`;
export const NavigationWrapper = styled.div`
    position: fixed;
    z-index: 100001;
    height: 100%;
    background: #fff;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 360px;
    transform: ${(props) => (props.navigationIsOpen ? 'translateX(0px)' : 'translateX(-360px)')};
    transition: 0.5s;
    @media (max-width: 360px) {
        width: 100%;
    }
`;
export const Navigation = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    background: #fff;
    padding: 18px 15px 24px 15px;
    width: 360px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (max-width: 767px) {
        padding: 10px 15px 24px 15px;
    }
    @media (max-width: 360px) {
        width: 100%;
    }
`;
export const Content = styled.div``;
export const CloseButton = styled.div`
    position: relative;
    width: 22px;
    height: 22px;
    &:hover {
        cursor: pointer;
    }
    &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        width: 5px;
        height: 26px;
        background: #000;
    }
    &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-45deg);
        width: 5px;
        height: 26px;
        background: #000;
    }
`;
export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 17px;
`;
export const TheInscriptionBeforebutton = styled.div`
    color: #000;
    font-size: 24px;
    text-align: center;
    letter-spacing: 1.2px;
    line-height: 29px;
    margin: 20px 0;
    @media (max-width: 767px) {
        font-size: 22px;
        line-height: 24px;
        margin: 10px 0;
    }
`;
export const Line = styled.div`
    width: 340px;
    height: 0;
    border: 1px solid #cccccc;
    margin-left: -7px;
`;
export const List = styled.div``;
export const listItem = styled(Link)`
    height: 48px;
    display: flex;
    position: relative;
    align-items: center;
    &:hover {
        text-decoration: none;
        cursor: pointer;
    }
    @media (max-width: 767px) {
        height: 38px;
    }
`;
export const listItemRegularLink = styled.a`
    height: 48px;
    display: flex;
    align-items: center;
    &:hover {
        text-decoration: none;
        cursor: pointer;
    }
    @media (max-width: 767px) {
        height: 38px;
    }
`;
export const Icon = styled.div`
    width: 24px;
    display: flex;
    justify-content: center;
    margin-right: 11px;
`;
export const ItemName = styled.div`
    color: #4f4f4f;
    font-size: 22px;
`;
export const BoldGreyText = styled.div`
    color: #737373;
    font-weight: bold;
    font-size: 22px;
    text-transform: uppercase;
    margin: 30px 0 6px 0;
`;
export const Footer = styled.div`
    display: flex;
    margin-top: 10px;
    justify-content: center;
    letter-spacing: 1.2px;
    font-size: 18px;
    color: #000000;
    a {
        color: #00b357;
        font-weight: 600;
    }
    a:hover {
        text-decoration: none;
    }
`;
export const numberOfItemsInTheBasket = styled.div`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #ff304c;
    color: #fff;
    font-weight: bold;
    font-size: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
